query DaDataFindOrganizationByInn($inn: String!, $kpp: String) {
  dadataFindOrganizationByInn(inn: $inn, kpp: $kpp) {
    suggestions {
      value
      unrestricted_value
      data {
        inn
        kpp
        ogrn
        name {
          full_with_opf
          short_with_opf
          full
          short
        }
        address {
          value
          unrestricted_value
        }
        management {
          name
          post
        }
        state {
          status
        }
      }
    }
  }
}
